/**
 * Main JavaScript functionality
 *
 * @package Peak_Pickleball
 */
import imagesLoaded from 'imagesloaded';

/**
 * Body related utilities
 *
 * Handles image loading, button styling, and navigation functionality.
 *
 * @since 1.0.0
 */
function bodyUtils() {
	imagesLoaded(document.body, function () {
		document.body.classList.add('loaded');

		const loadedEvent = new CustomEvent('body_loaded');
		document.body.dispatchEvent(loadedEvent);
	});
}

/**
 * Window scroll event utilities
 *
 * Handles header visibility based on scroll direction using requestAnimationFrame.
 *
 * States:
 * - natural: At or near top of page
 * - sticky: Scrolling up after passing threshold
 * - hidden: Scrolling down after passing threshold
 *
 * @since 1.0.0
 */
function windowScrollUtils() {
	const header = document.querySelector('.site-header, header.wp-block-template-part');
	const html = document.documentElement;

	if (!header) {
		console.warn('[Header] Header element not found');
		return;
	}

	const DELTA = 5;
	const HIDE_OFFSET = 100;
	const NATURAL_THRESHOLD = 50;

	let lastScrollY = 0;
	let ticking = false;

	const updateHeader = () => {
		const scrollY = window.scrollY;
		const scrollDelta = scrollY - lastScrollY;

		// State: Natural (at or near top)
		if (scrollY <= NATURAL_THRESHOLD) {
			html.classList.remove('header--sticky', 'header--hidden');
			html.classList.add('header--natural');
			lastScrollY = scrollY;
			return;
		}

		// Ignore small scroll movements
		if (Math.abs(scrollDelta) < DELTA) return;

		// Check if menu is open
		const menuOpen = document.querySelector(
				'.toggleBtn.open, .site-header__nav-toggle--js[aria-expanded="true"]'
		);

		if (!menuOpen) {
			if (scrollDelta > 0 && scrollY > HIDE_OFFSET) {
				// Scrolling DOWN past offset
				html.classList.remove('header--natural', 'header--sticky');
				html.classList.add('header--hidden');
			} else if (scrollDelta < 0) {
				// Scrolling UP
				html.classList.remove('header--natural', 'header--hidden');
				html.classList.add('header--sticky');
			}
		}

		lastScrollY = scrollY;
	};

	const onScroll = () => {
		if (!ticking) {
			requestAnimationFrame(() => {
				updateHeader();
				ticking = false;
			});
			ticking = true;
		}
	};

	// Set initial state
	html.classList.add('header--natural');

	window.addEventListener('scroll', onScroll, { passive: true });

	// Return cleanup function
	return () => {
		window.removeEventListener('scroll', onScroll);
	};
}

export { bodyUtils, windowScrollUtils };

document.addEventListener('DOMContentLoaded', function () {
	bodyUtils();
	windowScrollUtils();
});
